import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { forwardRef, useRef } from 'react';
import Glyphicon from '../Glyphicon/index.js';

/**
 *  SelectButton is a button styled to imitate select dropdowns for use as a trigger for PopoverSheet, BottomSheet, and
 * other expanding components.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SelectButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    primaryLabel,
    secondaryLabel,
    isActive,
    onClick,
    disabled,
    boldSecondaryLabel = true,
    inputCompletedState,
    ...rest
  } = _ref;
  // Update CSS accordingly for select button that has been completed once
  const userHasSelected = useRef(false);
  if (inputCompletedState) {
    userHasSelected.current = true;
  }
  return /*#__PURE__*/_jsxs("button", {
    ref: ref,
    "data-cmp": "selectButton",
    className: clsx({
      'form-group-inside-label': primaryLabel,
      'form-group-inside': !primaryLabel,
      'select-btn-completed': userHasSelected.current,
      'select-btn-active': isActive
    }, 'select-btn form-control', className),
    type: "button",
    onClick: onClick,
    disabled: disabled,
    ...rest,
    children: [primaryLabel && /*#__PURE__*/_jsx("span", {
      className: "select-btn-label",
      children: primaryLabel
    }), /*#__PURE__*/_jsx("span", {
      className: clsx({
        'select-btn-value': primaryLabel,
        'text-normal': !boldSecondaryLabel
      }),
      children: secondaryLabel
    }), /*#__PURE__*/_jsx(Glyphicon, {
      glyph: isActive ? 'menu-up' : 'menu-down',
      className: "select-btn-glyph"
    })]
  });
});
export default SelectButton;